var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"80px","background":"linear-gradient(-90deg, #02203d, #001527)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }